import React from 'react';
import PropTypes from 'prop-types';

export default function Info({ width, height }) {
  return (
    <svg width={width} height={height} viewBox="0 0 512 512">
<g>
	<g>
		<path d="M437.019,74.982C388.667,26.628,324.381,0,256,0S123.333,26.628,74.982,74.982C26.628,123.333,0,187.619,0,256
			s26.628,132.667,74.982,181.019C123.333,485.372,187.619,512,256,512s132.667-26.628,181.019-74.981
			C485.372,388.667,512,324.381,512,256S485.372,123.333,437.019,74.982z M256,491.602c-129.911,0-235.602-105.69-235.602-235.602
			S126.089,20.398,256,20.398S491.602,126.089,491.602,256S385.911,491.602,256,491.602z"/>
	</g>
</g>
<g>
	<g>
		<path d="M462.131,298.131c-5.464-1.392-11.012,1.907-12.4,7.367c-5.689,22.34-15.158,43.377-28.142,62.528
			c-3.161,4.663-1.943,11.004,2.719,14.166c1.753,1.188,3.744,1.758,5.715,1.758c3.268,0,6.48-1.568,8.451-4.478
			c14.313-21.11,24.751-44.306,31.024-68.94C470.888,305.073,467.591,299.52,462.131,298.131z"/>
	</g>
</g>
<g>
	<g>
		<path d="M466.104,245.801c-5.632,0-10.199,4.567-10.199,10.199c0,2.915-0.063,5.855-0.188,8.739
			c-0.244,5.628,4.121,10.387,9.749,10.63c0.15,0.007,0.299,0.01,0.448,0.01c5.43,0,9.945-4.282,10.182-9.759
			c0.138-3.176,0.207-6.412,0.207-9.62C476.303,250.368,471.736,245.801,466.104,245.801z"/>
	</g>
</g>
<g>
	<g>
		<path d="M256,172.877c-19.683,0-35.697,16.014-35.697,35.697V386.04c0,19.683,16.014,35.697,35.697,35.697
			c19.683,0,35.697-16.014,35.697-35.697V208.574C291.697,188.89,275.683,172.877,256,172.877z M271.299,386.04
			c0,8.436-6.863,15.299-15.299,15.299c-8.436,0-15.299-6.863-15.299-15.299V208.574c0-8.436,6.863-15.299,15.299-15.299
			c8.436,0,15.299,6.863,15.299,15.299V386.04z"/>
	</g>
</g>
<g>
	<g>
		<path d="M281.235,100.707c-6.652-6.638-15.851-10.444-25.235-10.444c-9.385,0-18.584,3.806-25.246,10.453
			c-6.642,6.644-10.451,15.844-10.451,25.244c0,9.384,3.806,18.583,10.46,25.251c6.652,6.639,15.851,10.446,25.237,10.446
			c9.385,0,18.584-3.807,25.251-10.461c6.639-6.652,10.446-15.851,10.446-25.236C291.697,116.56,287.888,107.359,281.235,100.707z
			 M266.827,136.773c-2.858,2.85-6.804,4.486-10.827,4.486c-4.026,0-7.972-1.636-10.813-4.47c-2.85-2.858-4.486-6.805-4.486-10.828
			c0-4.032,1.633-7.976,4.469-10.813c2.858-2.85,6.805-4.486,10.83-4.486c4.024,0,7.971,1.636,10.819,4.478
			c2.847,2.847,4.479,6.79,4.479,10.82C271.299,129.985,269.663,133.931,266.827,136.773z"/>
	</g>
</g>
    </svg>

  )
}

Info.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired
}
